import { render, staticRenderFns } from "./ActiveView.vue?vue&type=template&id=665e4815&"
import script from "./ActiveView.vue?vue&type=script&lang=js&"
export * from "./ActiveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports